import { antiTarnishJewellery, products } from "../../constants/ProductConstants";
import ProductCard from "../../components/product-card/ProductCard";
import '../../components/product-grid/ProductGrid.css';

export default function AntiTarnishJewelleryPage({ addToCart, title="Anti-tarnish Jewellery", subtitle="Browse our premium anti-tarnish collection.", productsList=[] }) {

  return (
    <section style={styles.container}>
      <h1 style={styles.title}>{title}</h1>
      <p style={styles.subtitle}>{subtitle}</p>

      <div className="product-grid">
        {productsList.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            addToCart={addToCart}
          />
        ))}
      </div>
    </section>
  );
}

const styles = {
  container: {
    padding: "20px 20px"
  },
  title: {
    fontSize: "28px",
    fontWeight: "600",
    marginBottom: "8px",
    textAlign: "center"
  },
  subtitle: {
    textAlign: "center",
    color: "#666",
    marginBottom: "24px"
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "20px"
  }
};
